import { useFlag } from '@cognite/react-feature-flags';

export enum FeatureFlags {
  /** Checks if the Galactica app is activated for the current tenant. */
  enabledDigitalTwins,
  /** Checks if the Data Quality Explorer is activated for the current tenant. */
  enabledDataQualityExplorer,
  /** Checks if the Data Consistency feature is activated for the current tenant. */
  enabledDataConsistency,
  /** Checks if the Access Control UI os enabled for the current tenant. */
  enabledAccessControl,
  /** Checks if the feature to copy milestones, rulesets and rules is enabled for the current tenant. */
  enabledCopyRules,
  /** Checks if property comparison is enabled */
  enabledPropertyComparison,
  /** Checks if is unique condition for a rule is enabled */
  enabledIsUnique,
  /** Checks if is ends with for a rule is enabled */
  enabledEndsWith,
  /** Checks if is regex for a rule is enabled */
  enabledRegex,
}

export const useFeatureFlag = (featureFlags: FeatureFlags) => {
  const flagKeyMap: Record<FeatureFlags, string> = {
    [FeatureFlags.enabledDigitalTwins]: 'ITG_DIGITAL_TWINS',
    [FeatureFlags.enabledDataQualityExplorer]: 'GALACTICA_DATA_QUALITY',
    [FeatureFlags.enabledDataConsistency]: 'GALACTICA_DATA_CONSISTENCY',
    [FeatureFlags.enabledAccessControl]: 'GALACTICA_ACCESS_CONTROL',
    [FeatureFlags.enabledCopyRules]: 'GALACTICA_COPY_RULES',
    [FeatureFlags.enabledPropertyComparison]: 'GALACTICA_PROPERTY_COMPARISON',
    [FeatureFlags.enabledIsUnique]: 'GALACTICA_IS_UNIQUE',
    [FeatureFlags.enabledEndsWith]: 'GALACTICA_ENDS_WITH',
    [FeatureFlags.enabledRegex]: 'GALACTICA_REGEX',
  };

  const key = flagKeyMap[featureFlags];
  const flagValue = useFlag(key, { forceRerender: true });

  return flagValue;
};
